export default "assets/lines-light-7c26d584.svg";